import camelCase from 'lodash/camelCase';
import { QUESTIONS_FOR_TAX } from '../../../models/survey';
import { CheckoutState } from '../../../state';
import { getQuestionsCollection } from '../pureSelectors';

/**
 * @private Do not use this directly, derive information from `getSurvey` instead
 */
export const getHasTaxQuestions = (state: CheckoutState) => {
    const allSurveyQuestionNames = Object.keys(getQuestionsCollection(state));
    const uniqueQuestionsForTaxNames = new Set(
        Object.values(QUESTIONS_FOR_TAX).map(
            (name) => `N-${camelCase(name.replace(/^N-/, ''))}`,
        ),
    );
    return allSurveyQuestionNames.some((name) =>
        uniqueQuestionsForTaxNames.has(name),
    );
};
